const generateImageUrl = imageName => {
  if (!imageName) return "";
  return `https://topnotch-asset.s3-us-west-2.amazonaws.com/${imageName}`;
};

export default generateImageUrl;
